// extracted by mini-css-extract-plugin
export default {"table-header-cell":"UserGroupsList_table-header-cell__YAs0F"};